<ng-container *transloco="let t; prefix: 'common.breadcrumb'">
<ol class="breadcrumb" *ngIf="(breadCrumbs | union: [(extraBreadCrumbs ?? [])]) as crumbs">
  <li *ngFor="let breadcrumb of crumbs; last as isLast"
      class="breadcrumb-item" [class.text-break]="isLast">
    <a *ngIf="!isLast" [routerLink]="getRouteParams(breadcrumb)">{{ t(breadcrumb.label, {prefix: 'common.breadcrumb'}) }}</a>
    <span class="text-primary" *ngIf="isLast">{{ t(breadcrumb.label, {prefix: 'common.breadcrumb'} ) }}</span>
  </li>
  <ng-content></ng-content>
</ol>
</ng-container>
